<template>
  <div>
    <el-form :model="form" :rules="rules" ref="form" label-width="100px" class="demo-form">
      <el-form-item label="资讯名称" prop="infoName">
        <el-input v-model="form.infoName"></el-input>
      </el-form-item>
      <el-form-item label="资讯类型">
        <el-button type="primary" @click="selectClick" size="mini">选择政策分类</el-button>
        <el-table :data="tableColumnListList" border style="width: 100%">
          <el-table-column
            v-for="(item,index) in tableColumn"
            :key="index"
            :prop="item.prop"
            :label="item.label"
            header-align="center"
            :width="item.time=='time'?400:''"
          >
            <template slot-scope="scope">
              <div v-if="item.type=='state'">
                <div style="text-align:center">
                  <el-tag v-if="scope.row[item.prop]==1">待提交</el-tag>
                  <el-tag v-if="scope.row[item.prop]==2">待审核</el-tag>
                  <el-tag v-if="scope.row[item.prop]==3" type="success">通过</el-tag>
                  <el-tag v-if="scope.row[item.prop]==4" type="danger">不通过</el-tag>
                  <el-tag v-if="scope.row[item.prop]==5" type="warning">撤销通过</el-tag>
                </div>
              </div>
              <div
                v-else
                :style="{'text-align':item.align?item.align:'center'}"
              >{{scope.row[item.prop]}}</div>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="danger" size="small" @click="remove(scope.row)">移除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
      <el-form-item label="内容" prop="content">
        <quillEditor class="ql-editor" v-model="form.content" :options="editorOption"></quillEditor>
      </el-form-item>
      <el-form-item label="发布平台">
        <el-checkbox-group v-model="form.platform">
          <el-checkbox label="1">app</el-checkbox>
          <el-checkbox label="2">公众号</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
    </el-form>
    <div class="button" v-if="buttonType=='add'">
      <el-button type="primary" @click="save">添加</el-button>
      <el-button type="info" @click="cancel">取消</el-button>
    </div>
    <div class="button" v-if="buttonType=='compile'">
      <el-button type="success" @click="save">编辑</el-button>
      <el-button type="info" @click="cancel">取消</el-button>
    </div>
    <!--  -->
    <el-dialog title="选择资讯类型" :visible.sync="selectVisible" :modal="false" width="70%">
      <!-- 表格 -->
      <div class="table">
        <el-table
          ref="multipleTable"
          :data="tableData"
          border
          style="width: 100%"
          @select="handleSelectionChange"
          @select-all="changeAll"
          row-key="id"
        >
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column
            v-for="(item,index) in tableColumn"
            :key="index"
            :prop="item.prop"
            :label="item.label"
            header-align="center"
          >
            <template slot-scope="scope">
              <div :style="{'text-align':item.align?item.align:'center'}">{{scope.row[item.prop]}}</div>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[5, 10, 20, 50]"
            :page-size="5"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="sure">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import editor_option from "../../../../utils/editorOption.js";
import { quillEditor } from "vue-quill-editor";
import {
  ConsultEdit,
  ConsultCheck,
  ConsultTypeList,
  ConsultTypeCheck
} from "../api/index.js";
export default {
  components: { quillEditor },
  props: ["title", "buttonType", "row"],
  data() {
    return {
      form: {
        platform: []
      },
      rules: {
        infoName: [{ required: true, message: "请输入标题", trigger: "blur" }]
      },
      editorOption: editor_option.editorOption,
      dialogVisible: "", //政策的分类
      tableData: [], //
      tableColumn: [
        {
          prop: "typeName",
          label: "分类名称"
        },
        {
          prop: "infoExplain",
          label: "分类说明"
        }
      ],
      totalHome: "",
      currentPageHome: "",
      selectChildrenList: [],
      tableColumnListList: [],
      selectVisible: false,
      pageNo: 1,
      pageSize: 10,
      total: 1,
      currentPage: 1
    };
  },
  methods: {
    //取消
    cancel(e) {
      this.$emit("cancel");
    },
    //保存按钮
    save() {
      this.$refs.form.validate(valid => {
        if (valid) {
          if (
            !this.tableColumnListList ||
            this.tableColumnListList.length == 0
          ) {
            this.$message({
              type: "warning",
              message: "请先选择资讯类型"
            });
            return false;
          }
          
          this.form = Object.assign({}, this.form, {
            informationTypeId: this.tableColumnListList[0].id,
            informationTypeName: this.tableColumnListList[0].typeName,
            platform: this.form.platform[0],
            state: '0'
          });
          ConsultEdit(this.form).then(res => {
            this.$message({
              type: "success",
              message: this.form.id ? "编辑成功!" : "添加成功!"
            });
            this.$emit("cancel");
          });
        }
      });
    },
    //回写拿到数据
    helpAddAPI(e) {
      ConsultCheck(e).then(res => {
        this.form = Object.assign({}, res.content, {
          platform: [res.content.platform]
        });
        //根据id查政策分类回写
        ConsultTypeCheck({ id: res.content.informationTypeId }).then(
          res => {
            this.tableColumnListList = [];
            this.tableColumnListList.push(res.content);
          }
        );
      });
    },
    //选择政策分类
    handleSelectionChange(val) {
      if (val && val.length > 0) {
        this.$refs.multipleTable.clearSelection();
        this.$refs.multipleTable.toggleRowSelection(val[val.length - 1], true);
        this.selectChildrenHome = [val[val.length - 1]];
      } else {
        this.selectChildrenHome = [];
      }
      this.childrenShow = true;
    },
    //点击选择政策分类全选按钮
    changeAll(e) {
      this.$message({
        message: "无法全选",
        type: "warning"
      });
      this.$refs.multipleTable.clearSelection();
      this.selectChildrenHome = [];
    },
    //选择政策分类
    selectClick() {
      this.selectVisible = true;
      this.ConsultTypeListAPI();
    },
    //移除选择的政策分类
    remove(e) {
      let index = this.tableColumnListList.findIndex(item => item.id == e.id);
      this.tableColumnListList.splice(index, 1);
    },
    //拿到政策分类的列表
    ConsultTypeListAPI(e) {
      let params = Object.assign({}, e, {
        pageNo: this.pageNo,
        pageSize: this.pageSize
      });
      ConsultTypeList(params).then(res => {
        this.tableData = res.content.list;
        this.total = res.content.count;
      });
    },
    //政策分类每页请求数据
    handleSizeChange(val) {
      this.pageSize = val;
      this.ConsultTypeListAPI();
      this.$message({
        message: `每页请求${val}条数据成功`,
        type: "success"
      });
    },
    //政策分类请求第几数据
    handleCurrentChange(val) {
      this.pageNo = val;
      this.ConsultTypeListAPI();
      this.$message({
        message: `请求第${val}页数据成功`,
        type: "success"
      });
    },
    //选择政策分类确定按钮
    sure() {
      this.tableColumnListList = this.selectChildrenHome;
      this.selectVisible = false;
    }
  },
  created() {
    if (this.buttonType == "check" || this.buttonType == "compile") {
      this.helpAddAPI({ id: this.row.id });
    }
  }
};
</script>

<style scoped >
.left {
  width: 45%;
  display: inline-block;
}
.right {
  width: 45%;
  display: inline-block;
  /* float: right; */
}
.flex {
  display: flex;
}
.itemSelect {
  width: 30%;
}
.map {
  width: 100%;
  height: 120px;
  background-color: red;
}
.button {
  width: 400px;
  margin: 10px auto 0px;
  display: flex;
  justify-content: space-between;
}
.title {
  border: 1px solid rgb(175, 175, 175);
  text-align: center;
  padding: 10px 0px;
  margin: 10px 0px;
}
.el-form-item__content {
  display: flex !important;
}
.el-form-item {
  margin-bottom: 20px !important;
}
</style>